import React from "react";

export default class Footer extends React.Component {

    render() {
        return (
            <div className="footer-container">
                <div className="footer-upper">
                    <div className="footer-upper-upper">
                        <p>We value our community. Follow us on social media.</p>
                        <div className="side-bar-social">
                            <div>
                                <div className="icon-div">
                                    <i class="fa fa-facebook" aria-hidden="true"></i>
                                </div>
                                <div className="icon-div">
                                    <i class="fa fa-twitter" aria-hidden="true"></i>
                                </div>
                                <div className="icon-div">
                                    <i class="fa fa-instagram" aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-upper-links">
                        <ul>
                            <li>About</li>
                            <li>About the dev</li>
                            <li>Previous work</li>
                            <li>Blog</li>
                        </ul>
                        <ul>
                            <li>Resources</li>
                            <li>Support Center</li>
                            <li>Documentation</li>
                            <li>Newsletter</li>
                        </ul>
                        <ul>
                            <li>Follow Us On</li>
                            <li>Facebook</li>
                            <li>Instagram</li>
                            <li>Twitter</li>
                        </ul>
                        <ul>
                            <li>Contact</li>
                            <li>
                                New York. 100 N <br />
                                99th St, Georgia <br />
                                (1) 304-992-2231 <br />
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-lower">Made by Cheboi. All rights reserved.</div>
            </div>
        )
    }
}